import { inject } from '@angular/core';
import { Router, Routes } from '@angular/router';
import { BlankComponent } from './layouts/blank/blank.component';
import { FullComponent } from './layouts/full/full.component';
import { authGuard } from './guards/auth.guard';
import { AuthService } from './services/auth.service';

/** Redirige vers la page d'accueil correspondant au rôle de l'utilisateur */
const homeRedirect = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (!auth.isLoggedIn) {
    return router.createUrlTree(['/authentication/login']);
  }
  return router.createUrlTree([auth.defaultRouteForRole()]);
};

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    canActivate: [homeRedirect],
    children: [],
  },
  {
    path: '',
    component: FullComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'dinki',
        loadChildren: () =>
          import('./pages/dinki/dinki.routes').then((m) => m.DINKI_ROUTES),
      },
    ],
  },
  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: 'authentication',
        loadChildren: () =>
          import('./pages/authentication/authentication.routes').then(
            (m) => m.AuthenticationRoutes,
          ),
      },
    ],
  },
  // ─── Pages publiques (À propos, Blog, Licence — sans login) ──────────
  // Chemins explicites (pas de path:'' pour éviter tout conflit de matching
  // avec les autres routes racine). Traduites via ngx-translate (pages.*).
  {
    path: 'about',
    loadComponent: () =>
      import('./pages/public/about-us/about-us.component').then(
        (m) => m.AboutUsComponent,
      ),
  },
  {
    path: 'blog',
    loadComponent: () =>
      import('./pages/public/blog/blog.component').then((m) => m.BlogComponent),
  },
  {
    path: 'license',
    loadComponent: () =>
      import('./pages/public/license/license.component').then(
        (m) => m.LicenseComponent,
      ),
  },
  // ─── Portail Customer (magic-link, sans login) ───────────────────────
  // Routes accessibles publiquement par les clients finaux des ateliers via
  // le lien envoyé en SMS/WhatsApp/Email. Pas de layout principal, pas de
  // sidebar, pas d'auth — seul le token dans l'URL importe.
  {
    path: 'c',
    loadChildren: () =>
      import('./pages/portal/portal.routes').then((m) => m.PORTAL_ROUTES),
  },
  {
    path: '**',
    redirectTo: 'authentication/error',
  },
];
